exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub_title[data-v-b5486a22] {\n    font-size: 70%;\n    color: rgba(0, 0, 0, 0.5);\n}\n.page-header[data-v-b5486a22] {\n    font-size: 50px;\n    font-weight: 800;\n    margin-left: 20px;\n    color: rgba(0, 0, 0, 0.9);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/components/HeaderTitle.vue?vue&type=style&index=0&id=b5486a22&scoped=true&lang=css&
// module id = f3r0
// module chunks = 58